var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGeoLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 88.85 65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.68,24.46c5.03,0,12.05-1.55,17.42-4,6.57-3,11.6-6.94,22.7-6.94,4.96,0,9.34,1.04,13.18,2.68V0H12.39V20.65c4.46,2.08,9.34,3.81,13.29,3.81Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8,40.52c-5.23-.21-9.39,1.89-14.64,4.29-6.5,2.96-14.58,6.65-25.48,6.65-4.89,0-9.33-1.11-13.29-2.81v16.34H78.99v-21.03c-3.87-1.79-8.4-3.26-13.18-3.45Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M88.85,31.53c-7.86-8.77-15.77-13.22-23.55-13.22-7.12,0-14.18,4.88-21.64,10.04-6.75,4.66-13.73,9.49-19.41,9.49-7.4,0-18.09-12.2-24.25-21.38v14.85c6.45,7.52,15.4,15.53,24.25,15.53s16.64-5.63,24.53-11.08c6-4.15,12.21-8.44,16.53-8.44,9.19,0,18.69,11.53,23.55,18.96v-14.74Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeoLogo);
export default __webpack_public_path__ + "static/media/geo-logo.7ca5f80e7f49c96b42690722b91a0797.svg";
export { ForwardRef as ReactComponent };